import * as Progress from "@radix-ui/react-progress";

export default function SpecialPlaybackProgress({
  playbackProgress,
}: {
  playbackProgress: number | undefined;
}) {
  const roundProgressValue = (value: number | undefined) => {
    if (!value) return null;

    // round any negative values to 0
    if (value < 0) return 0;

    // round any values greater than 100
    if (value > 100) return 100;

    // otherwise, we must be between 0 and 100
    return value;
  };

  const progressValue = roundProgressValue(playbackProgress);

  // only render progress if > 2%
  if (!(progressValue && progressValue > 2)) return null;

  return (
    <Progress.Root
      value={progressValue}
      className="flex w-full h-[7px] -mt-[7px] bg-transparent rounded-b-xl transform-[translateZ(0)] relative overflow-hidden"
    >
      <Progress.Indicator
        className="w-full h-full bg-primary"
        style={{
          transform: `translateX(-${100 - progressValue}%)`,
        }}
      />
    </Progress.Root>
  );
}
